/* RDA100 theme v3 extras. Includes fail-safe data fallback to guarantee rendering. */
(function () {
  "use strict";
  
  const LABELS = { 
    leucine: "L-Leucine", isoleucine: "L-Isoleucine", valine: "L-Valine", 
    lysine: "L-Lysine", threonine: "L-Threonine", phenylalanine: "L-Phenylalanine", 
    histidine: "L-Histidine", methionine: "L-Methionine", tryptophan: "L-Tryptophan" 
  };

  function ingredients(el) {
    let profile = null;

    // 1. Try to get live data from rda.js
    if (window.RDA && typeof window.RDA.product === 'function') {
      const p = window.RDA.product("rda100");
      if (p && p.profile) profile = p.profile;
    }

    // 2. FAIL-SAFE: Agar live data na mile, toh image wale exact numbers use karein
    if (!profile) {
      console.warn("Live data missing. Using fallback formula data.");
      profile = {
        leucine: 3.00, lysine: 1.50, isoleucine: 1.10, valine: 1.10,
        threonine: 1.00, phenylalanine: 1.00, histidine: 0.55,
        methionine: 0.50, tryptophan: 0.25
      };
    }

    // Format helper function
    const fmt = (num, dec) => Number(num).toFixed(dec);

    // Sort descending by amount
    const keys = Object.keys(LABELS).sort((a, b) => profile[b] - profile[a]);
    const total = keys.reduce((sum, k) => sum + profile[k], 0);
    
    // Inject HTML matching your CSS requirements
    el.innerHTML = keys.map((k) => 
      `<div class="rda-ingr-row${k === "leucine" ? " lead" : ""}">` +
        `<span>${LABELS[k]}${k === "lysine" ? " <small>(active, from lysine HCl)</small>" : ""}</span>` +
        `<span class="dots"></span>` +
        `<span class="v">${fmt(profile[k], 2)} g</span>` +
      `</div>`
    ).join("") +
    `<div class="rda-ingr-total"><span class="rda-small">all nine EAAs</span><span class="t">${fmt(total, 1)} g</span></div>`;
  }

  function rail(ctl, track) {
    if(!track) return;
    const btns = ctl.querySelectorAll("[data-dir]");
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 18) : track.clientWidth; };
    const sync = () => { const max = track.scrollWidth - track.clientWidth - 2; btns.forEach((b) => { b.disabled = b.dataset.dir === "-1" ? track.scrollLeft <= 2 : track.scrollLeft >= max; }); };
    btns.forEach((b) => b.addEventListener("click", () => track.scrollBy({ left: step() * parseInt(b.dataset.dir, 10), behavior: "smooth" })));
    track.addEventListener("scroll", () => requestAnimationFrame(sync), { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }

  function gallery(el) {
    const thumbs = Array.from(el.querySelectorAll(".rda-thumbs button"));
    const dots = Array.from(el.querySelectorAll(".rda-dots i"));
    if (!thumbs.length) return;
    const cur = () => Math.max(0, thumbs.findIndex((t) => t.getAttribute("aria-current") === "true"));
    const mark = (i) => dots.forEach((d, j) => d.classList.toggle("on", j === i));
    thumbs.forEach((t, i) => t.addEventListener("click", () => mark(i)));
    const go = (d) => { const n = (cur() + d + thumbs.length) % thumbs.length; thumbs[n].click(); };
    const prev = el.querySelector(".nav.prev"), next = el.querySelector(".nav.next");
    if (prev) prev.addEventListener("click", () => go(-1));
    if (next) next.addEventListener("click", () => go(1));
    
    let x0 = null;
    const main = el.querySelector(".main");
    if(main) {
      main.addEventListener("touchstart", (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener("touchend", (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); x0 = null; });
    }
  }

  function init() {
    document.querySelectorAll('[data-rda3="ingr"]').forEach(ingredients);
    document.querySelectorAll('[data-rda3="rail"]').forEach((w) => rail(w, w.querySelector(".rda-rail")));
    document.querySelectorAll('[data-rda3="rail-ctl"]').forEach((c) => { const t = document.getElementById(c.dataset.target); if (t) rail(c, t); });
    document.querySelectorAll('[data-rda3="gallery"]').forEach(gallery);
    document.querySelectorAll("[data-rda3-share]").forEach((b) => b.addEventListener("click", () => {
      if(window.RDA && window.RDA.sharePop) {
        window.RDA.sharePop(b, { url: location.origin + location.pathname, text: "RDA100 Protein Aminos: 10 g of all nine essential amino acids in one lemon scoop. Every number on the site links to its source." });
      }
    }));
  }

  // Turant run karega, ab data delay ka wait nahi karna padega
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();